import React, { useState } from "react";
import emailjs from "emailjs-com";

// Components

import TitleBox from "../components/TitleBox";
import Buttons from "../components/Buttons";
import Footer from "../components/Footer";

// CSS

import "./css/ContactUs.scss";

const Contact = ({ setActivateToast, setToastProps }) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  function validateEmail(email) {
    const res =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return res.test(String(email).toLowerCase());
  }

  function sendEmail(e) {
    e.preventDefault();

    setActivateToast(true);

    // Check if the user is a bot

    if (document.getElementById("txtHp").value !== "") {
      return;
    }

    // Validate

    if (document.getElementById("txtName").value === "") {
      setToastProps({
        message: "Please enter your full name.",
        style: "error",
      });
      return;
    } else if (document.getElementById("txtMsg").value === "") {
      setToastProps({
        message: "Please tell us your message.",
        style: "error",
      });
      return;
    } else if (document.getElementById("txtContactNo").value === "") {
      setToastProps({
        message: "Please enter your contact number.",
        style: "error",
      });
      return;
    } else {
      if (document.getElementById("txtEmail").value === "") {
        setToastProps({
          message: "Please enter your e-mail address.",
          style: "error",
        });
        return;
      } else {
        if (!validateEmail(document.getElementById("txtEmail").value)) {
          setToastProps({
            message: "Please enter a valid e-mail address.",
            style: "error",
          });
          return;
        }
      }
    }

    emailjs
      .sendForm(
        "service_2ixigf6",
        "template_3bhvuot",
        e.target,
        "HV_joK_FYMcA8msEV"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    setToastProps({
      message: "Your e-mail has been successfully sent!",
      style: "success",
    });
    e.target.reset();
  }

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });
  return (
    <div
      className='contact-us-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Contact Us"} />

      <div className='contact-us-inner'>
        <div className='info-container'>
          <h1>Visit Us</h1>
          <div className='scroller'>
            <div className='info-title'>Address</div>
            <div className='info-desc'>
              3rd Flr. LSS Building, #107 13th Avenue, Brgy. Socorro, Cubao,
              Quezon City, Philippines
            </div>
            <div className='info-title'>Email</div>
            <div className='info-desc'>ghsi_info@getwellhealthinc.com.ph</div>
            <div className='info-title'>Trunkline Number</div>
            <div className='info-desc'>
              Mon - Fri, 8:00AM to 6:00PM
              <ul className='custom-list'>
                <li>+63 (2) 8913-8893</li>
                <li>+63 (2) 8912-4196</li>
                <li>+63 (2) 8912-4132</li>
              </ul>
            </div>
            <div className='info-title'>Fax</div>
            <div className='info-desc'>
              Mon - Fri, 8:00AM to 6:00PM
              <ul className='custom-list'>
                <li>+63 (2) 8285-0610</li>
              </ul>
            </div>
            <div className='info-title'>Hotline</div>
            <div className='info-desc'>
              24/7
              <ul className='custom-list'>
                <li>+63 (2) 664-2580</li>
                <li>+63 (929) 161-9274 (SMART)</li>
                <li>+63 (946) 133-9790 (TALK & TEXT)</li>
                <li>+63 (916) 260-6241 (GLOBE)</li>
                <li>+63 (917) 526-0465 (GLOBE)</li>
                <li>+63 (932) 988-3252 (SUN)</li>
                <li>+63 (922) 388-4953 (SUN)</li>
              </ul>
            </div>
          </div>
        </div>
        <div className='form-container'>
          <form
            method='POST'
            id='contactFormMain'
            onSubmit={(e) => sendEmail(e)}
          >
            <div className='label required'>Name</div>
            <input
              id='txtName'
              type='text'
              name='name'
              placeholder='Name'
              className='custom-input'
            />
            <input type='text' id='txtHp' />
            <div className='label required'>Email</div>
            <input
              id='txtEmail'
              type='text'
              name='email'
              placeholder='Email'
              className='custom-input'
            />
            <div className='label required'>Contact Number</div>
            <input
              id='txtContactNo'
              name='phone'
              type='text'
              placeholder='Contact Number'
              className='custom-input'
            />
            <div className='label required'>Message</div>
            <textarea
              id='txtMsg'
              name='message'
              placeholder='Enter your message here...'
              rows='2'
              className='custom-input'
            ></textarea>
            <Buttons
              text='Send Message'
              color='secondary'
              type='submit'
              style={{
                marginLeft: "auto",
                marginTop: "2.5%",
                width: "100%",
                background: "var(--primary-gradient)",
                border: "none",
              }}
            />
          </form>
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default Contact;
